/* THIS IS A GENERATED FILE, DO NOT EDIT */
export const iconCollection = [
    "address-book",
    "address-card",
    "alarm-clock",
    "alien",
    "align-center",
    "align-left",
    "align-right",
    "angles-left",
    "angles-right",
    "archive",
    "arrow-down-a-z",
    "arrow-down-arrow-up",
    "arrow-down-left-and-arrow-up-right-to-center",
    "arrow-down",
    "arrow-left-to-line",
    "arrow-left",
    "arrow-progress",
    "arrow-right-arrow-left",
    "arrow-right-from-bracket",
    "arrow-right-to-line",
    "arrow-right",
    "arrow-rotate-left",
    "arrow-rotate-right",
    "arrow-turn-down-left",
    "arrow-up-long",
    "arrow-up-right-and-arrow-down-left-from-center",
    "arrow-up-right-from-square",
    "arrow-up",
    "arrows-repeat",
    "arrows-rotate",
    "arrows-split-up-and-left",
    "asterisk",
    "at",
    "backward-step",
    "backward",
    "ban",
    "bars-chevron-left",
    "bars-chevron-right",
    "bars-slash",
    "bars",
    "basket-shopping",
    "bed",
    "bell-slash",
    "bell",
    "bicycle",
    "block-brick",
    "bold",
    "bolt-outline",
    "book-open",
    "book-user",
    "book",
    "bookmark-fill",
    "bookmark-outline",
    "books",
    "box-open",
    "box",
    "boxing-glove",
    "briefcase",
    "broom",
    "bsn",
    "building-columns",
    "building",
    "bullseye-arrow",
    "cake-candles",
    "calculator",
    "calendar-check",
    "calendar-clock",
    "calendar-day",
    "calendar-lines-pen",
    "calendar-minus",
    "calendar-month",
    "calendar-pen",
    "calendar-plus",
    "calendar-star",
    "calendar-week",
    "calendar-xmark",
    "calendar",
    "camera-cctv",
    "camera-rotate",
    "camera",
    "car-side",
    "car",
    "caret-down",
    "caret-left",
    "caret-right",
    "caret-up",
    "cart-shopping",
    "chart-bar",
    "chart-line-horizontal",
    "chart-line-up",
    "chart-line",
    "chart-network",
    "chart-pie",
    "check-double",
    "check-to-slot",
    "check",
    "chevron-down",
    "chevron-left",
    "chevron-right",
    "chevron-up",
    "children",
    "circle-check",
    "circle-exclamation",
    "circle-info",
    "circle-minus",
    "circle-plus",
    "circle-small",
    "circle-user",
    "circle-xmark",
    "circle",
    "circles-overlap",
    "clipboard-list-check",
    "clipboard-list",
    "clock-rotate-left",
    "clock",
    "clone",
    "cloud-arrow-down",
    "cloud",
    "code",
    "comment-question",
    "comment",
    "comments",
    "compass",
    "cookie-bite",
    "copy",
    "couch",
    "cov",
    "credit-card",
    "cross",
    "crown",
    "crutch",
    "crutches",
    "decrease-textsize",
    "delete-left",
    "desktop",
    "door-closed",
    "door-open",
    "dove",
    "download",
    "ear-deaf",
    "ear-listen",
    "ellipsis-stroke-vertical",
    "ellipsis-stroke",
    "envelope-open-text",
    "envelope",
    "envelopes-bulk",
    "equals",
    "eraser",
    "euro-sign",
    "eye-low-vision",
    "eye-slash",
    "eye",
    "face-frown-slight",
    "face-id",
    "face-meh",
    "face-smile",
    "family",
    "file-audio",
    "file-certificate",
    "file-circle-check",
    "file-circle-exclamation",
    "file-code",
    "file-contract",
    "file-csv",
    "file-doc",
    "file-gif",
    "file-image",
    "file-jpg",
    "file-lines",
    "file-lock",
    "file-magnifying-glass",
    "file-mp3",
    "file-mp4",
    "file-pdf",
    "file-png",
    "file-ppt",
    "file-video",
    "file-waveform",
    "file-xls",
    "file-zip",
    "file",
    "files",
    "filter-circle-xmark",
    "filter",
    "flag-checkered",
    "flag-fill",
    "flag-outline",
    "flask",
    "flickr",
    "folder-open",
    "folder-plus",
    "folder",
    "font",
    "forward-step",
    "forward",
    "foster-family",
    "gauge-high",
    "gavel",
    "gear",
    "gift-card",
    "gift",
    "globe",
    "google-drive",
    "graduation-cap",
    "grid-2",
    "grid-list",
    "grid",
    "grip-dots-vertical",
    "group-in-hand",
    "hammer-brush",
    "hammer",
    "hand-back-point-up",
    "hand-dots",
    "hand-fist",
    "hand-holding-box",
    "hand-holding-medical",
    "hand-holding-seedling",
    "hand-wave",
    "hand",
    "handcuffs",
    "hands-holding-circle",
    "hands-praying",
    "handshake",
    "hashtag",
    "head-side-brain",
    "head-side-medical",
    "head-side-swallow",
    "head-side-talking",
    "head-side",
    "headphones-simple",
    "heart-fill",
    "heart-outline",
    "heart-pulse-xmark",
    "heart-pulse",
    "highlight",
    "home",
    "hospital",
    "hourglass-half",
    "house-building",
    "house-chimney-heart",
    "house-chimney-medical",
    "house-chimney-user",
    "house-chimney",
    "house-circle-check",
    "house-circle-xmark",
    "house-lock",
    "house-medical",
    "house-person-leave",
    "icons",
    "id-card",
    "image",
    "inbox",
    "increase-textsize",
    "indent",
    "info",
    "italic",
    "jo-logo",
    "karify-archive-slash",
    "karify-chevron-down-slash",
    "karify-folder",
    "karify-healthspace",
    "karify-history",
    "karify-lock-slash",
    "karify-logo",
    "karify-minddistrict",
    "karify-puzzle-check",
    "karify-puzzle-pen",
    "karify-roqua",
    "karify-shield-folder",
    "karify-shield-history",
    "karify-shield",
    "karify-shopping-bag",
    "karify-shopping-basket",
    "karify-wing",
    "key",
    "keyboard",
    "layer-group",
    "light-emergency-on",
    "lightbulb-on",
    "link-simple",
    "link-slash",
    "link",
    "list-check",
    "list-ol",
    "list-tree",
    "list-ul",
    "location-crosshairs",
    "location-dot-slash",
    "location-dot",
    "lock-open",
    "lock-register",
    "lock-user",
    "lock",
    "logging",
    "lungs",
    "magnifying-glass-arrows-rotate",
    "magnifying-glass-minus",
    "magnifying-glass-plus",
    "magnifying-glass",
    "map-location-dot",
    "mars",
    "megaphone",
    "message-arrow-down",
    "message-sms",
    "message",
    "messages",
    "microphone-slash",
    "microphone",
    "microsoft-onedrive",
    "minus",
    "mobile",
    "money-bill-wave",
    "money-check-pen",
    "moon-cloud",
    "moon",
    "mug-hot",
    "mug-saucer",
    "netherlands",
    "newspaper",
    "note",
    "objects-column",
    "outdent",
    "palette",
    "paper-plane",
    "paperclip",
    "paste-from-word",
    "paste-text",
    "paste",
    "pause",
    "pen-to-square",
    "pen",
    "people-arrows",
    "people-carry-box",
    "people-group",
    "people-line",
    "person-chalkboard",
    "person-digging",
    "person-falling-burst",
    "person-falling",
    "person-helping",
    "person-in-hand",
    "person-star",
    "person-stars",
    "person-walking-with-cane",
    "person",
    "phone-hangup",
    "phone-missed",
    "phone-plus",
    "phone",
    "photo-film",
    "pills",
    "plate-utensils",
    "play",
    "plug",
    "plus",
    "prescription-bottle-medical",
    "presentation-screen",
    "print",
    "puzzle-piece-simple",
    "qrcode",
    "question",
    "quote-right",
    "receipt",
    "reply",
    "right-left",
    "rings-wedding",
    "road",
    "rocket-launch",
    "room",
    "rotate-exclamation",
    "route",
    "ruler",
    "scale-balanced",
    "scissors",
    "scroll",
    "sdb-logo",
    "share-nodes",
    "share",
    "shield-check",
    "shield-history",
    "shield-keyhole",
    "shield-plus",
    "shower",
    "shuffle",
    "signature",
    "signpost",
    "sitemap",
    "skype",
    "sliders",
    "sort",
    "spinner-scale",
    "square-check",
    "square-facebook",
    "square-parking",
    "stamp",
    "star-fill",
    "star-outline",
    "stethoscope",
    "stop",
    "stopwatch",
    "strikethrough",
    "suitcase-medical",
    "sun-bright",
    "sunglasses",
    "syringe",
    "table-cells",
    "table-columns",
    "table",
    "tag",
    "taxi-bus",
    "temperature-three-quarters",
    "text",
    "thought-bubble",
    "thumbs-down-fill",
    "thumbs-down-outline",
    "thumbs-up-fill",
    "thumbs-up-outline",
    "thumbtack-fill",
    "thumbtack",
    "timeline-arrow",
    "tombstone",
    "tooth",
    "toothbrush",
    "touch-id",
    "train-tram",
    "trash-can",
    "tree-city",
    "tree-palm",
    "triangle-exclamation",
    "trophy",
    "truck-medical",
    "umbrella-beach",
    "umbrella",
    "underline",
    "universal-access-dashed",
    "unlock-register",
    "unlock-user",
    "upload",
    "user-check",
    "user-clock",
    "user-crown",
    "user-doctor",
    "user-group",
    "user-hair",
    "user-invite",
    "user-lock",
    "user-magnifying-glass",
    "user-minus",
    "user-pen",
    "user-plus",
    "user-slash",
    "user-xmark",
    "user",
    "users-medical",
    "users",
    "vacuum",
    "venus-mars",
    "venus",
    "video-plus",
    "video-slash",
    "video",
    "volume-xmark",
    "volume",
    "wand-magic-sparkles",
    "whatsapp",
    "wheat",
    "wheelchair",
    "wid",
    "xmark",
];
export default iconCollection;
